import React from 'react';
import { colors } from 'helpers/colors';

function SvgMailtoSolidV2({ size = 30, color = colors.gray[700] }) {
  return (
    <svg width={size} viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.08333 0C3.00037 0 1.96175 0.417915 1.19598 1.16181C0.430207 1.9057 0 2.91464 0 3.96667V4.95833L12.25 11.3665L24.5 4.96032V3.96667C24.5 2.91464 24.0698 1.9057 23.304 1.16181C22.5382 0.417915 21.4996 0 20.4167 0H4.08333ZM24.5 6.61838L12.7339 12.7727C12.5852 12.8504 12.4189 12.8911 12.25 12.8911C12.0811 12.8911 11.9148 12.8504 11.7661 12.7727L0 6.61838V15.8667C0 16.9187 0.430207 17.9276 1.19598 18.6715C1.96175 19.4154 3.00037 19.8333 4.08333 19.8333H20.4167C21.4996 19.8333 22.5382 19.4154 23.304 18.6715C24.0698 17.9276 24.5 16.9187 24.5 15.8667V6.61838Z" fill={color}/>
    </svg>
  );
}

export default SvgMailtoSolidV2;
